import he from 'he';

// tipologie dei template email: nome leggibile e icona per lista e dettaglio
// (le stesse voci del select "Operazione" di Create.vue / Edit.vue)
export const TIPOLOGIE = {
	REGISTER_USER: { label: 'Registrazione utente', icona: 'mdi-account-plus-outline' },
	RESTORE_PASSWORD: { label: 'Ripristina password', icona: 'mdi-lock-reset' },
	NEWSLETTER_SUBSCRIPTION: { label: 'Iscrizione newsletter', icona: 'mdi-newspaper-variant-outline' },
	ORDER_CONFIRM: { label: 'Conferma ordine', icona: 'mdi-cart-check' },
	CHANGE_STATUS: { label: 'Cambio status', icona: 'mdi-swap-horizontal' },
	TRACKING_ORDER: { label: 'Tracking', icona: 'mdi-truck-fast-outline' },
	COMMUNICATION_EMPLOYEE: { label: 'Comunicazioni dipendente', icona: 'mdi-account-tie-voice-outline' },
	DOCUMENT_EMPLOYEE: { label: 'Documenti dipendente', icona: 'mdi-file-account-outline' },
	PRODUCT_AVAILABLE: { label: 'Prodotto disponibile', icona: 'mdi-package-variant-closed-check' },
	COUPON: { label: 'Coupon', icona: 'mdi-ticket-percent-outline' },
	RETURN: { label: 'Reso', icona: 'mdi-keyboard-return' },
	NOTIFY_ITEM_AVAILABLE: { label: 'Notifica prodotto di nuovo disponibile', icona: 'mdi-bell-ring-outline' },
	NOTIFY_PRICE_DROP: { label: 'Notifica prezzo in calo', icona: 'mdi-tag-arrow-down-outline' },
	AFFILIATE_INVOICE_INVITATION: { label: 'Invito a fatturare (affiliazione)', icona: 'mdi-receipt-text-outline' },
	AFFILIATE_TARGET_NOT_REACHED: { label: 'Obiettivo non raggiunto (affiliazione)', icona: 'mdi-target' },
	GIFT_CARD: { label: 'Gift Card', icona: 'mdi-gift-outline' },
	LOYALTY: { label: 'Scheda a punti', icona: 'mdi-star-circle-outline' },
};

// eventi della scheda a punti: richiesta di riscatto di un premio e suo esito
export const LOYALTY_STATUS = [
	{ value: 'Richiesta di riscatto ricevuta', _id: 'REQUESTED' },
	{ value: 'Riscatto confermato', _id: 'CONFIRMED' },
	{ value: 'Riscatto rifiutato', _id: 'REJECTED' },
];

export function tipologia(type) {
	return TIPOLOGIE[type] || { label: type || '—', icona: 'mdi-email-outline' };
}

// placeholder ammessi nel testo (vedi l'avviso nella scheda del template)
export const PLACEHOLDER = {
	name: 'nome utente',
	lastname: 'cognome utente',
	email: 'email utente',
	order: "numero dell'ordine",
	cart: 'prodotti nel carrello',
	item: 'link del prodotto (negli avvisi: riquadro con immagine e nome)',
	product: 'nome del prodotto (avvisi)',
	item_url: 'url del prodotto (avvisi)',
	item_image: 'immagine del prodotto (avvisi)',
	old_price: 'prezzo visto dal cliente (prezzo in calo)',
	new_price: 'nuovo prezzo (prezzo in calo)',
	saving: 'risparmio (prezzo in calo)',
	status: "status dell'ordine",
	courier: 'nome del corriere',
	tracking: 'numero del tracking',
	coupon: 'coupon con i dettagli della validità',
	store: "nome dell'attività",
	urlsito: 'url del sito',
	review: 'url per la recensione',
	message: "messaggio della gift card / messaggio dell'admin (scheda a punti)",
	code: 'codice di riscatto della gift card',
	reward: 'premio riscattato (scheda a punti)',
	points: 'punti scalati dal riscatto (scheda a punti)',
	balance: 'saldo punti residuo (scheda a punti)',
};

// testo senza tag: per capire se una lingua è davvero compilata
// (decodifica prima le entità: i template salvati arrivano con l'HTML codificato)
export function testoPiano(html) {
	return he
		.decode(String(html || ''))
		.replace(/<[^>]*>/g, ' ')
		.replace(/ /g, ' ')
		.trim();
}

// placeholder usati in oggetto, testo e pulsante di una traduzione, in ordine e senza doppioni
export function placeholderUsati(t) {
	const testo = [t && t.oggetto, t && t.text, t && t.button].filter(Boolean).join(' ');
	const trovati = (testo.match(/\[([a-zA-Z_]+)\]/g) || []).map(p => p.slice(1, -1));
	return [...new Set(trovati)];
}

export function bandiera(lang) {
	try {
		return require(`@/assets/images/flag/${String(lang || '').toUpperCase()}.svg`);
	} catch (e) {
		return require('@/assets/images/flag/map.svg');
	}
}
